const SCOPE = 'borrower-information';

export const BorrowerInformationTestIds = {
  LOAN_NUMBER_BUTTON: `${SCOPE}.loan-number-button`,
};
